import MainButton from '@ui-kit/components/mainButton';
import React, { ReactElement } from 'react';
import { t } from '@base/utils/helpers';

export type MenuButton = {
  title: string;
  onClick: () => void;
  icon?: ReactElement;
  visible?: boolean;
};

export default function GameMenuButtons(props: { buttons: MenuButton[] }) {
  return (
    <>
      {props.buttons.map((button) => (
        <MainButton
          key={button.title}
          onClick={button.onClick}
          secondary={new RegExp(t('cancel')).test(button.title)}
        >
          {button.title}
        </MainButton>
      ))}
    </>
  );
}
